
interface NewsCardProps {
  news: {
    id: number;
    date: string;
    category: string;
    title: string;
    excerpt: string;
    image: string;
    featured?: boolean;
  };
  featured?: boolean;
}

export default function NewsCard({ news, featured = false }: NewsCardProps) {
  const cardClass = featured 
    ? "bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 group cursor-pointer transform hover:-translate-y-1"
    : "bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer transform hover:-translate-y-1";

  const imageHeight = featured ? "h-64" : "h-48";

  return (
    <article className={cardClass}>
      <div className="relative overflow-hidden">
        <img
          src={news.image}
          alt={news.title}
          className={`w-full ${imageHeight} object-cover object-top transition-transform duration-300 group-hover:scale-105`}
        />
        <div className="absolute top-4 left-4">
          <span className="bg-black text-white px-3 py-1 rounded-full text-xs font-medium">
            {news.category}
          </span>
        </div>
        {featured && (
          <div className="absolute top-4 right-4">
            <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center">
              <i className="ri-fire-line mr-1"></i>
              注目
            </span>
          </div>
        )}
      </div>
      
      <div className={featured ? "p-8" : "p-6"}>
        <div className="flex items-center text-sm text-gray-500 mb-3">
          <i className="ri-calendar-line mr-2"></i>
          {news.date}
        </div>
        
        <h3 className={`font-bold mb-3 group-hover:text-gray-600 transition-colors ${
          featured ? "text-2xl" : "text-xl"
        }`}>
          {news.title}
        </h3>
        
        <p className={`text-gray-600 mb-4 leading-relaxed ${
          featured ? "text-lg" : ""
        }`}>
          {news.excerpt}
        </p>
        
        <div className="flex items-center text-black font-medium group-hover:text-gray-600 transition-colors">
          詳細を見る
          <i className="ri-arrow-right-line ml-2 transition-transform group-hover:translate-x-1"></i>
        </div>
      </div>
    </article>
  );
}
